import { CommonModule } from '@angular/common';
import { Component, EventEmitter, OnDestroy, inject } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { ClarityModule } from '@clr/angular';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject, Subscription } from 'rxjs';
import { first } from 'rxjs/operators';

import { getDirection, getFormVals } from 'src/app/misc/direction';
import { BackendLocaleDatePipe } from 'src/app/pipes/get-locale-date.pipe';
import { HideIDColumnsPipe } from 'src/app/pipes/hide-idcolumns.pipe';
import { MrTranslatePipe } from 'src/app/pipes/mr-translate.pipe';
import { MrUnitTextPipe } from 'src/app/pipes/mrUnitText.pipe';
import { ObjTypePipe as objtype } from 'src/app/pipes/objtype.pipe';
import { AuthService } from 'src/app/services/Auth/auth.service';
import { SpinnerService } from 'src/app/services/Spinner/spinner.service';
import { LinieValidationManager } from 'src/app/shared/classes/linie-validation-manager';
import { APIService } from 'src/app/services/APIService/api.service';
import { TextBoolDgCell } from '../../_shared/datagrid-cell/text-bool-dg-cell';

@Component({
  selector: 'app-sperrungdialog',
  templateUrl: './sperrungdialog.component.html',
  styleUrls: ['./sperrungdialog.component.scss'],
  imports: [
    CommonModule,
    ClarityModule,
    FormsModule,
    ReactiveFormsModule,
    objtype,
    MrTranslatePipe,
    BackendLocaleDatePipe,
    MrUnitTextPipe,
    HideIDColumnsPipe,
    TextBoolDgCell,
  ],
})
export class SperrungDialogComponent extends LinieValidationManager implements OnDestroy {
  private apiservice = inject(APIService);
  private toastr = inject(ToastrService);
  private spinner = inject(SpinnerService);
  private authService = inject(AuthService);
  private mrTranslate = inject(MrTranslatePipe);
  protected localeDate = inject(BackendLocaleDatePipe);

  ostammid: number;
  typ_Line_Point: number = undefined;
  pointtype: number = undefined;
  startmeter: number = undefined;
  endmeter: number = undefined;

  mode: string = 'new';
  editId: number = undefined;

  gemeldetDurch: any;
  aufgehobenDurch: any;
  history: any;

  public closedialog: BehaviorSubject<boolean> = new BehaviorSubject(false);
  dataRefresh = new EventEmitter();

  sperrungGroup = new UntypedFormGroup({
    date: new UntypedFormControl(BackendLocaleDatePipe.now),
    edate: new UntypedFormControl(''),
    time: new UntypedFormControl(''),
    etime: new UntypedFormControl(''),

    gemeldetDurch: new UntypedFormControl(''),
    aufgehobenDurch: new UntypedFormControl(''),

    ew: new UntypedFormControl(''),

    gl_g: new UntypedFormControl(''),
    gl_v: new UntypedFormControl(''),
    gl_b: new UntypedFormControl(''),

    dw_a: new UntypedFormControl(''),
    dw_b: new UntypedFormControl(''),
    dw_c: new UntypedFormControl(''),

    kr_a: new UntypedFormControl(''),
    kr_b: new UntypedFormControl(''),
    kr_c: new UntypedFormControl(''),
    kr_d: new UntypedFormControl(''),

    gesperrt: new UntypedFormControl(''),
    grund: new UntypedFormControl(''),
  });

  maxlen: number = undefined;
  sub = new Subscription();
  set data(dataIn: any) {
    this.ostammid = dataIn.id;
    this.typ_Line_Point = dataIn.typ_Line_Point;
    this.pointtype = dataIn.pointtype;
    if (dataIn.startmeter || dataIn.endmeter) {
      this.startmeter = dataIn.startmeter;
      this.endmeter = dataIn.endmeter;
      const sub = this.sperrungGroup.get('gl_g').valueChanges.subscribe(value => {
        if (value != this.sperrungGroup.value.gl_g) {
          if (!value) this.initLinieValidators(this.startmeter, this.endmeter);
          else this.clearLinieValidators();
        }
      });
      this.sub.add(sub);
      this.initLinieValidators(this.startmeter, this.endmeter);
    }
    if (dataIn.dataRefresh) {
      this.dataRefresh = dataIn.dataRefresh;
    }

    this.apiservice
      .getSperrung(this.ostammid)
      .pipe(first())
      .subscribe((sperr: any) => {
        if (sperr.gemeldetDurch) {
          this.gemeldetDurch = sperr.gemeldetDurch.map(user => user.busername);
        }

        if (sperr.aufgehobenDurch) {
          this.aufgehobenDurch = sperr.aufgehobenDurch.map(user => user.eusername);
        }
        if (sperr.history) {
          this.history = sperr.history;
          if (sperr.history.rows.length == 1 && this.history.rows[0].ende != null) this.history.rows[0].aktiv = true;
        }

        /* if (sperr.maxlen) {
          this.maxlen = sperr.maxlen;
          this.sperrungGroup.controls.gl_b.setValidators([
            Validators.min(0),
            Validators.max(sperr.maxlen),
          ]);
          this.sperrungGroup.controls.gl_v.setValidators([
            Validators.min(0),
            Validators.max(sperr.maxlen - 1),
          ]);
        } else {
          this.maxlen = undefined;
          this.sperrungGroup.controls.gl_b.setValidators([]);
          this.sperrungGroup.controls.gl_v.setValidators([]);
        } */
      });
  }

  trial = false;

  constructor() {
    super({ start: 'gl_v', end: 'gl_b' });
    this.form = this.sperrungGroup;
    this.trial = this.authService.getToken().trial;
  }

  selectRadio(val: any) {
    this.sperrungGroup.controls.ew.setValue(val);
  }

  camelcase(val: string) {
    return val.replace(/([A-Z])/g, ' $1').replace(/^./, function (str) {
      return str.toUpperCase();
    });
  }

  onSubmit() {
    let data = this.sperrungGroup.value;
    Object.keys(data).forEach(key => {
      if (data[key] === '' || data[key] == 'Invalid date') {
        delete data[key];
      }
    });

    data.gesperrt = data.gesperrt ? true : false;
    data.grund = data.grund ? data.grund : '';

    let config = '';
    let gleisData;
    let direction = 0;
    if (objtype.isLine(this.typ_Line_Point)) {
      if (
        data.gl_g ||
        (data.gl_v !== null &&
          data.gl_v !== undefined &&
          data.gl_v !== '' &&
          data.gl_b !== null &&
          data.gl_b !== undefined &&
          data.gl_b !== '')
      ) {
        direction = 99;
        gleisData = {
          g: data.gl_g,
          v: data.gl_v,
          b: data.gl_b,
        };
        config = 'gl';
      }
    } else if (objtype.isPoint(this.typ_Line_Point)) {
      switch (this.pointtype) {
        case 1:
          if (data.ew) {
            direction = data.ew;
            config = 'ew';
          }
          break;
        case 2:
          if (data.dw_a || data.dw_b || data.dw_c) {
            direction = getDirection([data.dw_a, data.dw_b, data.dw_c]);
            config = 'dw';
          }
          break;
        case 3:
          if (data.kr_a || data.kr_b || data.kr_c || data.kr_c || data.kr_d) {
            direction = getDirection([data.kr_a, data.kr_b, data.kr_c, data.kr_d]);
            config = 'kr';
          }
          break;
      }
    }

    let sendObj = {
      operation: this.mode,
      editId: this.editId ? this.editId : undefined,
      date: this.localeDate.addTimeToDate(data.date || BackendLocaleDatePipe.now, data.time),
      edate: this.localeDate.addTimeToDate(data.edate, data.etime),
      gemeldetDurch: data.gemeldetDurch,
      aufgehobenDurch: data.aufgehobenDurch,
      mode: config,
      direction: direction,
      gleisData: gleisData ? gleisData : undefined,
      gesperrt: data.gesperrt,
      grund: data.grund,
    };

    let err = [];

    if (this.sperrungGroup.status != 'VALID' || this.sperrungGroup.errors) {
      err.push('Formularvalidierung (rot) beachten');
    }

    if (this.pointtype && config == '') {
      err.push('Bitte eine Richtung / Gleisabschnitt auswählen');
    } else {
      if (objtype.isLine(this.typ_Line_Point)) {
        if (!sendObj.gleisData) {
          err.push('Gleisinformationen ausfüllen');
        } else {
          if (parseFloat(sendObj.gleisData.v) > parseFloat(sendObj.gleisData.b)) {
            err.push('von < bis');
          }
        }
      } else if (objtype.isPoint(this.typ_Line_Point)) {
        if (this.pointtype && !sendObj.direction) {
          err.push('Richtung ausfüllen');
        }
      }
    }

    if (err.length == 0) {
      this.spinner.enable();
      this.apiservice
        .sendSperrung(this.ostammid, sendObj)
        .pipe(first())
        .subscribe((res: any) => {
          if (res.message && res.message == 'success') {
            if (this.mode == 'new') {
              this.toastr.success(this.mrTranslate.transform('Daten gespeichert'));
            } else {
              this.toastr.success(this.mrTranslate.transform('Daten gespeichert'));
              this.editId = undefined;
              this.mode = 'new';
            }
            this.sperrungGroup.reset({ date: BackendLocaleDatePipe.now });
            if (res.history) {
              if (!this.history?.columns?.length) {
                this.history.columns = res.history.columns;
              }
              this.history.rows = res.history.rows;
            }
            this.dataRefresh?.emit(true);
          } else {
            this.toastr.error(this.mrTranslate.transform('Ein Fehler ist aufgetreten'));
          }
          this.spinner.disable();
        });
    } else {
      this.toastr.warning(
        '<ul>' + err.map(e => `<li>${this.mrTranslate.transform(e)}</li>`).join('') + '</ul>',
        this.mrTranslate.transform('Bitte folgendes beachten:'),
        {
          enableHtml: true,
        }
      );
    }
  }

  switchMode(newMode: string) {
    if (newMode == 'new') {
      this.sperrungGroup.reset({ date: BackendLocaleDatePipe.now });
      this.editId = undefined;
    }
    this.mode = newMode;
  }

  editRow(row: any) {
    this.sperrungGroup.reset();
    this.sperrungGroup.controls.gesperrt.setValue(row.aktiv);
    this.sperrungGroup.controls.date.setValue(row.beginn);
    this.sperrungGroup.controls.time.setValue(row.beginn?.slice(-8));

    this.sperrungGroup.controls.edate.setValue(row.ende);
    this.sperrungGroup.controls.etime.setValue(row.ende?.slice(-8));
    this.sperrungGroup.controls.aufgehobenDurch.setValue(row.endeBenutzername);

    this.sperrungGroup.controls.gl_v.setValue(row.startmeter);
    this.sperrungGroup.controls.gl_b.setValue(row.endmeter);
    this.sperrungGroup.controls.grund.setValue(row.grund);
    this.sperrungGroup.controls.gemeldetDurch.setValue(row.beginnBenutzername);

    if (objtype.isPoint(this.typ_Line_Point)) {
      let formvals = getFormVals(row.richtung);
      if (Array.isArray(formvals)) {
        if (formvals.length == 3) {
          this.sperrungGroup.controls.dw_a.setValue(formvals[0]);
          this.sperrungGroup.controls.dw_b.setValue(formvals[1]);
          this.sperrungGroup.controls.dw_c.setValue(formvals[2]);
        } else if (formvals.length == 4) {
          this.sperrungGroup.controls.kr_a.setValue(formvals[0]);
          this.sperrungGroup.controls.kr_b.setValue(formvals[1]);
          this.sperrungGroup.controls.kr_c.setValue(formvals[2]);
          this.sperrungGroup.controls.kr_d.setValue(formvals[3]);
        }
      } else {
        this.sperrungGroup.controls.ew.setValue(formvals.toString());
      }
    }

    this.editId = row.id;
    this.mode = 'edit';
  }

  emailSperrung(row) {
    const datum = this.localeDate.transform(row.beginn);
    const zeit = this.localeDate.transformTime(row.beginn);
    const translate = (value: string) => this.mrTranslate.transform(value);
    const yes = translate('Ja');
    const no = translate('Nein');
    const emailsubject = translate('Sperrung vom {0} {1}').replace('{0}', datum).replace('{1}', zeit);
    let emailbody = `
          *********************************************
          *                   ${translate('Sperrung')}                *
          *********************************************\n
          ${translate('Beginn der Sperrung')}: ${datum} ${translate('Zeit Beginn')}: ${zeit}
          ${translate('gemeldet durch')}: ${row.beginnBenutzername}\n
          *********************************************\n
          ${translate('Gesamtes Gleis?')}: ${row.richtung ? yes : no}
          ${translate('von')}: ${row.startmeter} ${translate('bis')}: ${row.endmeter}
          ${translate('Gesperrt?')}: ${row.aktiv ? yes : no}
          ${translate('Grund')}: ${row.grund ? row.grund : ''}
          `;

    let mailtolink = 'mailto:?subject=' + encodeURIComponent(emailsubject) + '&body=' + encodeURIComponent(emailbody);
    //Wird self verwendet, verlieren wir den Window Context und alle Observables funktionieren nicht mehr.
    //_blank kann man NICHT verwenden wenn man debuggt da der sich aufhängt aber der Context bleibt erhalten.
    //Also diese Funktion nicht beim Debuggen verwenden.
    window.open(mailtolink, '');
  }

  public close() {
    this.closedialog.next(true);
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }
}
